import {
  Avatar,
  CardHeader,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import DomaineCompetenceForm from "./forms/DomaineCompetenceForm";
import { useQuery } from "../../../../hooks/useQuery";
import { showFullName } from "../../../../Helpers/utilsHelper";
import { NA } from "../../../../utils/utilities";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import CallIcon from "@mui/icons-material/Call";
import CakeIcon from "@mui/icons-material/Cake";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { GitHub, HomeOutlined, LinkedIn } from "@material-ui/icons";
import { AssociationMembreService } from "../../../../service/AssociationMembreService";
import StandardSkeletoon from "../../shares/loader/StandardSkeletoon";

const Identite = () => {
  const [educationFormDialogOpen, setEducationFormDialogOpen] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [formLoading, setFormLoading] = useState(false);

  const query = useQuery();
  const id_responsable = query.get("ref");
  const handleCloseEducationForn = () => {
    setEducationFormDialogOpen(false);
  };

  const handleFetchInformation = () => {
    setFormLoading(true);
    AssociationMembreService.find_one({
      id_responsable: id_responsable,
    })
      .then((res) => {
        if (res && res.data) {
          setUserInfo(res.data);
        }
      })
      .finally(() => {
        setFormLoading(false);
      });
  };

  useEffect(() => {
    handleFetchInformation();
  }, []);
  return (
    <>
      <DomaineCompetenceForm
        open={educationFormDialogOpen}
        onFormClose={handleCloseEducationForn}
      />
      <Paper>
        <StandardSkeletoon show={formLoading} escalier row={3} />
        <Grid item xs={12} width={"100%"} display={formLoading?"none":""}>
          <CardHeader sx={{ ml: 2 }} title="Identités de la personne" />
          <Grid
            container
            display={"flex"}
            pb={3}
            ml={3}
            alignItems={"center"}
            flexDirection={"row"}
          >
            <Grid>
              <Avatar
                sx={{
                  m: 1,
                  width: "clamp(100px, 15vw, 150px)",
                  height: "clamp(100px, 15vw, 150px)",
                  fontSize: "clamp(40px, 8vw, 80px)",
                  border: "2px solid #27262661",
                }}
                alt={showFullName(userInfo.nom, userInfo.prenoms)}
                src={userInfo.photo_link}
              />
            </Grid>
            <Grid flexGrow={1}>
              <CardHeader
                subheader={
                  <Grid>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <WorkOutlineIcon />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {`${userInfo.fonction || NA()}`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <HomeOutlined />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {`${userInfo.adresse || NA()}`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <CakeIcon />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                        }}
                      >
                        {`${userInfo.annee_naissance ? new Date().getFullYear() - userInfo.annee_naissance : "NA"} ans`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <CallIcon />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {` ${userInfo.telephone1 || NA()} / ${userInfo.telephone2 || ""}`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <EmailOutlinedIcon />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {`${userInfo.email || userInfo.email2 || NA()}`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <LinkedIn />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {`${userInfo.linkedin || NA()}`}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <GitHub />
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "0.95rem",
                            sm: "1.05rem",
                            md: "1.15rem",
                          },
                          wordBreak: "break-word",
                        }}
                      >
                        {`${userInfo.github || NA()}`}
                      </Typography>
                    </Stack>
                  </Grid>
                }
                component="div"
                title={
                  <Grid item xs={8}>
                    <Typography
                      property="name"
                      sx={{
                        fontSize: {
                          xs: "1.1rem",
                          sm: "1.3rem",
                          md: "1.6rem",
                        },
                        fontWeight: 600,
                        wordBreak: "break-word",
                      }}
                    >
                      {showFullName(userInfo.nom, userInfo.prenoms)}
                    </Typography>
                  </Grid>
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default Identite;
